
import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';
import DateTimePicker from 'react-datetime-picker';
import DateTimeRangePicker from '@wojtekmaj/react-datetimerange-picker';
// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import Slider from 'react-dynamic-time-slider'
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';

// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Popover from '@material-ui/core/Popover';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

// Component styles
import styles from './styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import AudioElement from './AudioElement'
import Grid from '@material-ui/core/Grid';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')



class Audios extends Component {
    constructor(props) {
        super(props);
        var nodes=(props.location.state.fromObjective.Nodos)
        var listNodes=[]                                                                                            
        nodes.map(node=>{
            if(node["nodo"]!=='Global'){
                listNodes.push(node)
            }
        })
        this.myCallback = this.myCallback.bind(this);
        var monitores = (props.location.state.fromObjective.Monitores)
        this.state = {
            objetive: this.props.match.params.objetivo_id,
            isStatePeriod: false,
            settingsEl: null,
            steps:this.props.location.state.fromObjective.Pasos,
            isRefresh: false,
            isInfo: null,
            nodes:listNodes,
            listMonitores:monitores,
            dateMoment:((moment().locale('es'))),
            dateBefore:moment().subtract({'hours': 1}).locale('es'),
            limit:moment().subtract({'days': 6}).locale('es'),
            limit2:((moment().locale('es'))),
            errors:["","Solo puede seleccionar un día", "Ambas fechas no pueden ser iguales","Fecha inicial no puede ser mayor a Fecha Final", 
                    "Fecha Termino no puede superar fecha actual", "Rango debe ser de una Hora"],
            indexError:0,
            isLoad:false,
            extendEl: null,
            nameNodo: "Todos los Isp",
            node: 0,
            begin:moment().subtract({'hours': 1}).locale('es'),
            end:((moment().locale('es'))),
            isLoadButton:false,
            modal:false
        };
    }

    myCallback = (dataFromChild) => {
        this.setState({
            isLoadButton:false,
        })
    }

    changeDate=()=>{
        const {dateBefore, dateMoment, indexError}=this.state
        if(indexError===0&&(dateBefore.format("YYYY-MM-DD H:mm:ss")!==this.state.begin.format("YYYY-MM-DD H:mm:ss")||
            dateMoment.format("YYYY-MM-DD H:mm:ss")!==this.state.end.format("YYYY-MM-DD H:mm:ss"))){
            this.setState({
                begin:dateBefore,
                end:dateMoment,
                isLoadButton:true,
                modal:false,
            })
        }
    }

    handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                isRefresh: false,
                nameNodo: nameNodo,
            })
        }
    }

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };
    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };

    handleShowPop = event => {
        this.setState({
            modal: true
        });
    };
    handleClosePop = () => {
        this.setState({
            modal: false
        });
    };

    handleClose = event => {
        this.props.onClose()
    };
    
    onChange=(date)=>{
        if((String(date[0])).substr(4,12)!==(String(date[1])).substr(4,12)){
            //console.log('mayor a un dia')
            if(this.state.limit>moment(date[0])){
                //console.log('si la fecha menor es menor al limite')
                this.setState({
                    indexError:1,
                    dateBefore:this.state.limit,
                    dateMoment:this.state.limit.add({'hours':1})
                })
            }else{
                //console.log('la fecha limite es menor a la menor')
                this.setState({
                    indexError:1,
                    dateBefore:moment(date[0]),
                    dateMoment:moment(date[0]).add({'hours':1})
                })
            }
            
        }else{
            //console.log('un dia', moment(date[1]).unix()-moment(date[0]).unix())
            if(moment(date[1]).unix()-moment(date[0]).unix()<=0){
                if(moment(date[1]).unix()-moment(date[0]).unix()<0){
                    //console.log('fecha menor mas grande ')
                    this.setState({
                        indexError:3,
                })
                }else{
                    //console.log('fecha igual')
                    this.setState({
                        indexError:2,
                    })
                }
            }else{
                if(this.state.limit2<moment(date[1])){
                    //console.log('limite mayor menor a fecha final')
                    this.setState({
                        indexError:4,
                        dateBefore:this.state.limit2.subtract({'hours':1}),
                        dateMoment:this.state.limit2
                    })
                        
                }else{
                    //console.log('rango')
                    if(moment(date[1]).unix()-moment(date[0]).unix()>3600){
                        //console.log('rango mayor a una hora')
                        this.setState({
                            indexError:5,
                            dateBefore:moment(date[0]),
                            dateMoment:moment(date[1]),
                        })
                    }else{
                        //console.log('funciona')
                        this.setState({
                            indexError:0,
                            dateBefore:moment(date[0]),
                            dateMoment:moment(date[1]),
                        })
                    }
                }
                
            }
        }
    }


    render() {
        
        const { classes, location } = this.props;
        const {listMonitores, nodes, steps, objetive, dateMoment, dateBefore, isLoad, extendEl, nameNodo, node, limit,
            errors, indexError, limit2, begin, end, isLoadButton, modal} = this.state;
        const showExtendEl = Boolean(extendEl);
        if (isLoad===true) {
            return(
                <div>
    
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"

                        size={12}
                        thickness={3}
                        
                    />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            return (
                <Portlet className={classes.backGrey}>
                    <Grid
                        item
                        xs={12}
                        md={12}
                        xl={12}
                        style={{textAlign:'right'}}
                    >
                        <IconButton key="close" aria-label="close" style={{color:"white"}} onClick={this.handleClose}><CloseIcon/></IconButton>
                    </Grid>
                    <PortletHeader>
                        <PortletToolbar style={{width:"100%"}}>
                            <Grid
                                container
                            >
                                <Grid
                                    item
                                    xs={12}
                                    md={12}
                                    xl={12}
                                >
                                    <Typography variant="h3" className={classes.textWhite}>Audios Ivr</Typography>
                                    
                                </Grid>
                                
                                
                                <Grid
                                    style={{textAlign:"left"}}
                                    item
                                    xs={4}
                                    md={4}
                                    xl={4}
                                >
                                    <Button
                                        color="primary"
                                        variant="text"
                                        onClick={this.handleShowExtend}
                                    >
                                        {nameNodo} <ArrowRightIcon />
                                    </Button>
                                    
                                    <Popover
                                        anchorEl={extendEl}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'right',
                                          }}
                                          transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                          }}
                                        onClose={this.handleCloseExtend}
                                        open={showExtendEl}
                                        >
                                        <div className="row1">
                                            <List component="div">
                                                {Object.values(location.state.fromObjective.Nodos).map(i => (
                                                    <ListItem
                                                        key={i.id_nodo}
                                                        className={classes.listItem}
                                                        component="div"
                                                    >
                                                        <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                                    </ListItem>))}
                                            </List>
                                        </div> 
                                    </Popover> 
                                </Grid>
                                <Grid
                                    style={{textAlign:"left"}}
                                    item
                                    xs={8}
                                    md={8}
                                    xl={8}
                                >
                                    <Button
                                        color="primary"
                                        variant="text"
                                        onClick={this.handleShowPop}
                                    >
                                        <Typography style={{color:"white"}} variant="button">Selecciona Horario</Typography>
                                    </Button>
                                </Grid>
                                <Modal
                                    aria-labelledby="simple-modal-title"
                                    aria-describedby="simple-modal-description"
                                    open={modal}
                                    onClose={this.handleClosePop}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: "400px",
                                        left:"580px",
                                        top:"-220px"
                                    }}
                                    disableAutoFocus={true}
                                    disableEnforceFocus={true}
                                    closeAfterTransition
                                    BackdropComponent={Backdrop}
                                    BackdropProps={{
                                        timeout: 500,
                                    }}
                                >                                    
                                    <Grid
                                        container
                                        style={{backgroundColor:"white"}}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            xl={12}
                                            style={{textAlign:"center", backgroundColor:"white"}}
                                        >
                                            <Typography style={{color:"red", textAlign:"center"}}>
                                                {errors[indexError]}
                                            </Typography>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            xl={12}
                                            style={{textAlign:"center", backgroundColor:"white"}}
                                        >
                                            <DateTimeRangePicker 
                                                className={classes.bWhite}
                                                clearIcon={null}
                                                onChange={this.onChange}
                                                value={[dateBefore._d, dateMoment._d]}
                                                format={"y-MM-dd HH:mm:ss"}
                                                minDate={limit._d}
                                                maxDate={limit2._d}
                                                rangeDivider=" Hasta "
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            xl={12}
                                            style={{textAlign:"center", backgroundColor:"white"}}
                                        >
                                            {isLoadButton? 
                                                <CircularProgress
                                                variant="indeterminate"

                                                size={12}
                                                thickness={3}
                                                
                                                />:
                                                <Button style={{backgroundColor:"#FF4500"}} onClick={this.changeDate.bind(this)}>
                                                    <Typography variant="button" className={classes.textWhite} >Filtrar</Typography>
                                                </Button>
                                            }
                                        </Grid>
                                    </Grid>
                                </Modal>
                            </Grid>
                        </PortletToolbar>
                    </PortletHeader>
                    
                        <AudioElement monitors={listMonitores} nodes={nodes} node={node} objective={objetive} steps={steps} 
                            dateBegin={begin} dateFinal={end} callbackFromParent={this.myCallback}
                        />
                </Portlet>
            )
        
        }

        
    }
}


export default
    compose(withRouter, withStyles(styles))(Audios);